import { checkoutOptimizationStepArraySchema } from "@redotech/redo-flows-common/advanced-flow-db-parser";
import * as z from "zod";

export const getCheckoutTreeFlowStepsById = {
  name: "getCheckoutTreeFlowStepsById" as const,
  input: z.object({ checkoutTreeId: z.string() }),
  output: z.object({
    steps: checkoutOptimizationStepArraySchema,
    isActive: z.boolean(),
    label: z.string(),
  }),
};

export type GetCheckoutTreeFlowStepsByIdOutput = z.infer<
  typeof getCheckoutTreeFlowStepsById.output
>;
